"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));

var Gardening = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Gardening, _React$PureComponent);

  var _super = (0, _createSuper2["default"])(Gardening);

  function Gardening() {
    (0, _classCallCheck2["default"])(this, Gardening);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(Gardening, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], this.props, /*#__PURE__*/_react["default"].createElement("path", {
        d: "M3,13 C3,17.9705627 7.02943725,22 12,22 C12,17.0294373 7.97056275,13 3,13 L3,13 Z M12,22 C16.9705627,22 21,17.9705627 21,13 C16.0294373,13 12,17.0294373 12,22 L12,22 Z M18,3 L18,8 C18,11.3137085 15.3137085,14 12,14 C8.6862915,14 6,11.3137085 6,8 L6,3 C6.74,3 7.47,3.12 8.16,3.39 C8.71,3.62 9.2,3.96 9.61,4.39 L12,2 L14.39,4.39 C14.8,3.96 15.29,3.62 15.84,3.39 C16.53,3.12 17.26,3 18,3 Z"
      }));
    }
  }]);
  return Gardening;
}(_react["default"].PureComponent);

var _default = Gardening;
exports["default"] = _default;